import React from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { CATALOG_NAVIGATION_TABS } from "../../../utils/Constants";
import MainSequence from "../MainSequence/MainSequence";
import LinkedCategoriesContainer from "../LinkedCategoriesContainer/LinkedCategoriesTool";
import LinkedCategoriesSearch from "../LinkedCategoriesSearchContainer/LinkedCategoriesSearch";
import ViewContextProvider from "../../../context/view-context";
import PrimaryToolbarSequence from "../../PrimaryToolbarSequence";
import CatalogNavigationTabs from "../../CatalogNavigationTabs";
import {
  selectCallerAccountId,
  selectIsLinkedCategoryFeatureEnabled,
} from "../../../store/app-config/AppConfigSelectors";

const CatalogContainer: React.FC = () => {
  const { url } = useRouteMatch();
  const selectedAccount = useSelector(selectCallerAccountId);
  const isLinkedCategoryFeatureEnabled = useSelector(
    selectIsLinkedCategoryFeatureEnabled,
  );

  return (
    <>
      {selectedAccount !== "" && (
        <PrimaryToolbarSequence navigationTabs={CatalogNavigationTabs} />
      )}
      <Switch>
        {isLinkedCategoryFeatureEnabled && (
          <Route path={`${url}/${CATALOG_NAVIGATION_TABS.LINK_CATEGORIES_TOOL}`}>
            <ViewContextProvider>
              <LinkedCategoriesContainer />
            </ViewContextProvider>
          </Route>
        )}
        {isLinkedCategoryFeatureEnabled && (
          <Route path={`${url}/${CATALOG_NAVIGATION_TABS.LINKED_CATEGORIES}`}>
            <ViewContextProvider>
              <LinkedCategoriesSearch />
            </ViewContextProvider>
          </Route>
        )}
        <Route path={`${url}`}>
          <MainSequence />
        </Route>
        <Redirect to={`${url}/${CATALOG_NAVIGATION_TABS.PRODUCTS}`} />
      </Switch>
    </>
  );
};

export default CatalogContainer;
